import { View } from './view'

export const SignFormSuccess = () => {
	return View()
}
